import React, { useState, useRef, useEffect } from "react";
import { Button } from "react-bootstrap";
import _ from "lodash";
import RecursiveTree from "../RecursiveTree";
import GQPopup from "../GQPopups/GQPopup";
import { useSelector } from "react-redux";

const SelectedModification = ({setModification, divStyle, disabled, error, startCodes = [],  type = "protein", redo = false, availableModCodes = null}) => {
  
  //const modData = fetch('/CAS_dictionary_with_UI.json');
  
  const modInput = useRef(null);
  const previousTypeRef = useRef(type);

  const [currentModSearch, setCurrentModSearch] = useState("");
  const [modificationsCodes, setModificationsCodes] = useState([]);
  const [modList, setModList] = useState([]);
  const [displayList, setDisplayList] = useState(null);

  const [unfilteredCounts, setUnfilteredCounts] = useState(new Map());

  const [edited, setEdited] = useState(false);

  const [highlightedPaths, setHighlightedPaths] = useState([]);


  const [multiSelect, setMultiSelect] = useState([]);
  const [holdingShift, setHoldingShift] = useState(false);
  const [holdingCtrl, setHoldingCtrl] = useState(false);

  const [modDbBrowser, setModDbBrowser] = useState(false);
  const toggle = useSelector(state => state.setToggle.toggle);
  const closeModDbBrowser = () => {
    setCurrentModSearch("");
    setModDbBrowser(false);
    setMultiSelect([]);

    //remove highlight from all paths
    setHighlightedPaths([]);
  };
  const SelectMulti = () => {
    // let newCodes = [...modificationsCodes];
    // multiSelect.forEach((modID) => {
    //   if (!newCodes.includes(modID)) {
    //     newCodes.push(modID);
    //   }
    // });
    setCurrentModSearch("");
    setModificationsCodes([...new Set(multiSelect)]);
    setModification([...new Set(multiSelect)]);
    setMultiSelect([]);
    setModDbBrowser(false);
  };

  useEffect(async () => {

    let tmpMap = new Map();
    // Fetch CAS dictionary from public folder
    const CmJson = await fetch(process.env.REACT_APP_FT_URL + '/modification_dictionary_full.json').then(res => res.json());
    for (let item of CmJson) {
        tmpMap.set(parseInt(item.Mod_ID), item);
    }
    setModList(CmJson);
     
    //make listenrs for shift and ctrl
    const handleKeyDown = (event) => {
      if (event.key === "Shift") {
        setHoldingShift(true);
        setHoldingCtrl(false);
      }
      if (event.key === "Control") {
        setHoldingCtrl(true);
        setHoldingShift(false);
      }
    };

    const handleKeyUp = (event) => {
      if (event.key === "Shift" || event.key === "Control") {
        setHoldingShift(false);
        setHoldingCtrl(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, []);

  const [dragStart, setDragStart] = useState(null);
  const [dragEnd, setDragEnd] = useState(null);



  useEffect(() => {
    //if(modificationsCodes.length == 0 && startCodes.length > 0){
      setModificationsCodes(startCodes)
      setModification(startCodes)
    //}
  }, [startCodes]);

  useEffect(() => {
    if(previousTypeRef.current !== type){
      previousTypeRef.current = type;
      setCurrentModSearch("");
      setMultiSelect([]);
      setHighlightedPaths([]);
      setModificationsCodes([]);
      setModification([]);
      setEdited(false);
    }
  }, [type, setModification]);

  const handleRemoveModification = (index) => {
    const newCodes = [...modificationsCodes];
    let item = newCodes.splice(index, 1);
    item = JSON.parse(item);
    if(item.name !== undefined){
      setHighlightedPaths((prev) => prev.filter((path) => path !== item.name));
    }
    setModificationsCodes(newCodes);
    setModification(newCodes);
  };

  const handleAddModification = (mod) => {
    if (mod && !modificationsCodes.includes(mod.Mod_ID)) {
      const newCodes = [...modificationsCodes, mod.Mod_ID];
      setModificationsCodes(newCodes);
      setModification(newCodes);
      setEdited(true);
    }
  };


  const modlistTreeAtom = {
    children: [],
    classification: "BASE",
    modData: [], //{Mod_ID: "", modification: ""} from modlist
    fullPath: "",
    totalCount: 0,
    currentCount: 0,

  }
  let [modTree, setModTree] = useState({});

  useEffect(() => {
    if (modList.length === 0 || displayList === null) {
      return;
    }

    var temp = _.cloneDeep(modlistTreeAtom);
    let tempList = _.cloneDeep(displayList);
    

    tempList.forEach((mod) => {

      let classificationAtom = _.cloneDeep(modlistTreeAtom);
      classificationAtom.fullPath = mod.classification_UI ? mod.classification_UI : "BASE";

      let classification = mod.classification_UI ? mod.classification_UI.split(/\//ig) : [];

      //remove all "" and undefined from classifications
      classification = classification.filter((cls) => cls !== "" && cls !== undefined);

      //foreach classification, remove ";" from start and end
      classification = classification.map((cls) => cls.replace(/^;|;$/g, ""));
      let myClass = classification[classification.length - 1] ? classification[classification.length - 1] : "BASE";

      //set Atom
      
      classificationAtom.classification = myClass;
      classificationAtom.modData.push({Mod_ID: mod.Mod_ID, modification: mod.modification, Abbreviation: mod.Abbreviation, base: mod.base});

      temp = insertIntoTree(temp, classificationAtom, classification);
    })

    //temp = sortTreeRecursive(temp);

    setModTree(temp)

  }, [displayList, currentModSearch, modList]);


  useEffect(() => {

    if(modList.length === 0){
      return;
    }

    // Build a Set of allowed Mod_IDs from the result set. When null (no restriction
    // provided or empty list), the full dictionary is shown (fall-back behavior).
    const allowedSet = Array.isArray(availableModCodes) && availableModCodes.length > 0
      ? new Set(availableModCodes.map(c => parseInt(c)))
      : null;

    if(displayList === null){
      // One-time cleanup: remove entries with missing classification_UI and normalize paths
      for(let i = 0; i < modList.length; i++){
        let clUI = modList[i].classification_UI;
        if(clUI === undefined || clUI === ""){
          modList.splice(i, 1);
          i--;
          continue;
        }
        modList[i].classification_UI = clUI.split(/\//ig).filter((cls) => cls !== "" && cls !== undefined).map((cls) => cls.replace(/^;|;$/g, "")).join('/');
      }
      // Apply the same type + allowedSet filters as the else branch so the initial
      // render is consistent with every subsequent render (prevents intermittent empty list).
      const workingList = modList.filter((mod) => {
        if(type === "protein"){
          return typeof mod.base_type === "string" && mod.base_type === "PRT";
        } else {
          return typeof mod.base_type === "string" && mod.base_type === "NUC";
        }
      }).filter(mod => !allowedSet || allowedSet.has(parseInt(mod.Mod_ID)));
      const counts = new Map();
      for (const m of workingList) {
        const clUI = m.classification_UI;
        if (clUI) counts.set(clUI, (counts.get(clUI) || 0) + 1);
      }
      setUnfilteredCounts(counts);
      setDisplayList(workingList);
    }else{
      let tmp = modList.filter((mod) => {
          if(type === "protein"){
            return (typeof mod.base_type === "string" && mod.base_type === "PRT")
          } else {
            return (typeof mod.base_type === "string" && mod.base_type === "NUC")
          }
      }).filter((mod) => mod.classification_UI !== undefined)
      .filter(mod => !allowedSet || allowedSet.has(parseInt(mod.Mod_ID)))
      .filter(
          (mod) => {
            let modString = mod.base.toLowerCase()+" "+
            mod.modification.toLowerCase()+" ("+
            mod.Abbreviation.toLowerCase()+")"
            return(
              (modString.toLowerCase().replaceAll(/[^a-zA-Z0-9]/ig,"").includes(currentModSearch.toLowerCase().replaceAll(/[^a-zA-Z0-9]/ig,"")) ||
              (mod.classification_UI.toLowerCase().replaceAll(/[^a-zA-Z0-9]/ig,"").includes(currentModSearch.toLowerCase().replaceAll(/[^a-zA-Z0-9]/ig,"")) && modDbBrowser)
              )
            )
          }
      );
      setDisplayList(tmp);
    }

  }, [currentModSearch, modList, modDbBrowser, availableModCodes, type]);

  // function sortTreeRecursive(node) {

  //   for (let i = 0; i < node.children.length; i++) {
  //     node.children[i] = sortTreeRecursive(node.children[i]);
  //   }

    
  //   node.modData.sort((a, b) => {
  //     if (a.classification < b.classification) {
  //       return -1;
  //     }
  //     if (a.classification > b.classification) {
  //       return 1;
  //     }
  //     return 0;
  //   });

  //   node.modData.sort((a, b) => {
  //     if (a.modification < b.modification) {
  //       return -1;
  //     }
  //     if (a.modification > b.modification) {
  //       return 1;
  //     }
  //     return 0;
  //   });

  //   // node.classification.forEach(element => {
      
  //   // });

  // }


  function insertIntoTree(node, ModTreeAtom, path = [], parentPath = "") {
    if (path.length === 0) {
      if(node.classification === ModTreeAtom.classification){
        node.modData.push(...ModTreeAtom.modData);
        node.currentCount = node.modData.length;
        return node;
      }
      console.error("Path length 0 but node classification does not match ModTreeAtom classification");
    }else if(path.length >= 1){
      let found = false;
      for(let i = 0; i < node.children.length; i++){
        if(node.children[i].classification === path[0]){
          found = true;
          let currentPath = parentPath ? parentPath + '/' + path[0] : path[0];
          node.children[i] = insertIntoTree(node.children[i], ModTreeAtom, path.slice(1), currentPath);
          return node;
        }
      }

      if(!found){
        let newChild = _.cloneDeep(modlistTreeAtom);
        newChild.classification = path[0];
        let currentPath = parentPath ? parentPath + '/' + path[0] : path[0];
        newChild.fullPath = currentPath;
        newChild.totalCount = unfilteredCounts.get(currentPath) || 0;
        newChild.currentCount = newChild.modData.length;
        node.children.push(insertIntoTree(newChild, ModTreeAtom, path.slice(1), currentPath));
        return node;
      }
    }
  }


  return (
    <>
    <div
      style={
        divStyle
          ? { ...divStyle, position: "relative" }
          : {
              padding: "5px",
              display: "flex",
              flexWrap: "wrap",
              alignItems: "flex-start",
              width: "100%",
              border: (error && edited) ? "1px solid red" : "1px solid #ccc",
              borderRadius: "4px",
              flexDirection: "row",
              cursor: "text",
              minHeight: "80px",
              position: "relative", // <-- key for dropdown positioning
            }
      }
      onClick={() => {
        modInput.current.focus();
      }}
      
    >
      {/* Chips and input in a flex row */}
      {modificationsCodes.length > 0 &&
        modificationsCodes.map((id, index) => {

        if(id != null){

          id = id+"";

          if(!id.startsWith("{")){            
              const mod = modList.find((m) => m.Mod_ID === id);
              if(mod != null){
              return (
                <div
                  key={index}
                  style={{
                    backgroundColor: "#add8e6",
                    padding: "1px 5px",
                    display: "flex",
                    alignItems: "center",
                    marginRight: "5px",
                    height: "fit-content",
                    whiteSpace: "nowrap",
                    flexShrink: 0,
                    marginBottom: "5px",
                    color: "#292929",
                  }}
                >
                  {mod.base}&nbsp;{mod.modification}{mod.Abbreviation && <span>&nbsp;(<span>{mod.Abbreviation}</span>)</span>}
                  <div
                    onClick={() => disabled ?  null : handleRemoveModification(index)}
                    style={{
                      cursor: disabled ? "not-allowed" : "pointer",
                      backgroundColor: "#8f8f8fff",
                      color: "white",
                      padding: "0 5px",
                      marginLeft: "5px",
                      height: "20px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ display: "flex", height: "26px" }}>×</span>
                  </div>
                </div>
              )}
          } else {

              let insertionJson = JSON.parse(id);
              if(insertionJson != null){
              return(

              <div
                key={index}
                style={{
                  backgroundColor: "#e0e6ad",
                  padding: "1px 5px",
                  display: "flex",
                  alignItems: "center",
                  marginRight: "5px",
                  height: "fit-content",
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                  marginBottom: "5px",
                  color: "#292929",
                }}
              >
                {insertionJson.name}
                <div
                  onClick={() => disabled ?  null : handleRemoveModification(index)}
                  style={{
                    cursor: disabled ? "not-allowed" : "pointer",
                    backgroundColor: "#8f8f8fff",
                    color: "white",
                    padding: "0 5px",
                    marginLeft: "5px",
                    height: "20px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <span style={{ display: "flex", height: "26px" }}>×</span>
                </div>
              </div>
              )}
          }
        }
      }
      )}

      {/* Input and dropdown wrapper */}
      <div style={{ position: "relative", flex: 1, minWidth: 120 }}>
        <input
          disabled={disabled}
          id="modificationInput"
          type="text"
          ref={modInput}
          value={currentModSearch}
          onChange={(e) => setCurrentModSearch(e.target.value)}
          placeholder={disabled ? "" : "Input modification"}
          autoComplete="off"
          style={{
            width: "100%",
            height: "fit-content",
            border: "none",
            outline: "none",
            background: "none",
            color: "inherit",
            whiteSpace: "nowrap",
            flexShrink: 0,
            minWidth: "120px",
            marginBottom: "5px",
          }}
        />
        {currentModSearch !== "" && displayList.length > 0 &&
            <div
              style={{
                top: "100%", // directly below input
                left: 0,
                right: 0,
                position: "absolute",
                backgroundColor: toggle? "white": "#292929",
                border: "1px solid #ccc",
                zIndex: 10,
                maxHeight: "200px",
                overflowY: "auto",
                width: "min-content",  // Expand to fit the widest option
                borderRadius: "4px",
              }}
            >
              <ul style={{ listStyleType: "none", padding: "5px", margin: 0, width: "min-content"}}>
                {!modDbBrowser && displayList
                  .sort((a, b) => {
                    const search = currentModSearch.toLowerCase().replaceAll(/[^a-zA-Z0-9]/ig,"");
                    const aAbbr = a.Abbreviation.toLowerCase().replaceAll(/[^a-zA-Z0-9]/ig,"");
                    const bAbbr = b.Abbreviation.toLowerCase().replaceAll(/[^a-zA-Z0-9]/ig,"");
                    const aStr = (a.base + " " + a.modification + " (" + a.Abbreviation + ")").toLowerCase().replaceAll(/[^a-zA-Z0-9]/ig,"");
                    const bStr = (b.base + " " + b.modification + " (" + b.Abbreviation + ")").toLowerCase().replaceAll(/[^a-zA-Z0-9]/ig,"");
                    
                    // Exact abbreviation match first
                    if (aAbbr === search && bAbbr !== search) return -1;
                    if (bAbbr === search && aAbbr !== search) return 1;
                    
                    // Abbreviation starts with search
                    if (aAbbr.startsWith(search) && !bAbbr.startsWith(search)) return -1;
                    if (bAbbr.startsWith(search) && !aAbbr.startsWith(search)) return 1;
                    
                    // Sort by position of match (earlier is better)
                    const aIndex = aStr.indexOf(search);
                    const bIndex = bStr.indexOf(search);
                    if (aIndex !== bIndex) return aIndex - bIndex;
                    
                    // Alphabetical fallback
                    return aStr.localeCompare(bStr);
                  })
                  .map((mod, index) => (
                    <li
                      key={mod.Mod_ID}
                      onClick={() => {
                        if(holdingShift || holdingCtrl){
                          //multi select mode
                          if(!multiSelect.includes(mod.Mod_ID)){
                            setMultiSelect([...multiSelect, mod.Mod_ID]);
                          }
                        }else if (!modificationsCodes.includes(mod.Mod_ID)) {
                          setMultiSelect([]); //clear multiselect
                          handleAddModification(mod);
                          setCurrentModSearch("");
                        }
                      }}
                      style={{ cursor: "pointer", padding: "2px 8px" }}
                    >
                      <span style={modificationsCodes.includes(mod.Mod_ID) ? { whiteSpace: "nowrap", color: "lightgray", cursor: "not-allowed" } : { fontWeight: "bold", whiteSpace: "nowrap" }}>
                        <div>{mod.base !=="" && <span>{mod.base}&nbsp;</span>}{mod.modification}{mod.Abbreviation !== "" && <span>&nbsp;(<span>{mod.Abbreviation}</span>)</span>}</div>
                      </span>
                    </li>
                  ))}
              </ul>
            </div>
          }
      </div>
    </div>
    <div style={{width: "100%", alignContent: "end", alignItems: "center", display: "flex", justifyContent: "flex-end", cursor: "pointer", paddingRight: "5px"}}>
      <span 
        style={{padding: "0 5px"}} 
        className={disabled ? "disabled" : "ftLinkBlue"}
        onClick={()=>{
          //clear selected modifications
          if(!disabled){
            setModificationsCodes([]);
            setModification([]);
          }
        }}
        >Clear
      </span>
      <span style={{height: "15px", borderRight: "1px solid #ccc"}}></span>
      <span 
        style={{padding: "0 5px"}} 
        className={disabled ? "disabled" : "ftLinkBlue"}
        onClick={async ()=>{
          //copy selected modifications to clipboard
          if(!disabled){
            console.log("copy:"+modificationsCodes.join(","))

            if(modificationsCodes.length > 0){
              try {
                await navigator.clipboard.writeText(modificationsCodes.join(", "));
                console.log('Text copied to clipboard');
              } catch (err) {
                console.error('Failed to copy text: ', err);
              }
            }
            
          }
        }}
        >Copy
      </span>
      <span style={{height: "15px", borderRight: "1px solid #ccc"}}></span>
      <span 
        style={{padding: "0 5px"}} 
        className={disabled ? "disabled" : "ftLinkBlue"}
        onClick={async ()=>{
          //paste modifications from clipboard
          if(!disabled){
            try{
              // Focus the input to ensure document has focus for clipboard access
              if(modInput.current){
                modInput.current.focus();
              }
              const text = await navigator.clipboard.readText();
              
              // Smart parsing to handle both regular IDs and JSON objects
              let codes = [];
              let currentToken = "";
              let depth = 0;
              
              for(let i = 0; i < text.length; i++){
                let char = text[i];
                if(char === '{'){
                  depth++;
                  currentToken += char;
                } else if(char === '}'){
                  depth--;
                  currentToken += char;
                  if(depth === 0 && currentToken.trim() !== ""){
                    codes.push(currentToken.trim());
                    currentToken = "";
                  }
                } else if(char === ',' && depth === 0){
                  if(currentToken.trim() !== ""){
                    codes.push(currentToken.trim());
                  }
                  currentToken = "";
                } else {
                  currentToken += char;
                }
              }
              
              // Don't forget the last token
              if(currentToken.trim() !== ""){
                codes.push(currentToken.trim());
              }
              
              let newCodes = [...modificationsCodes];
              codes.forEach(code => {
                if(code !== "" && !newCodes.includes(code)){
                  newCodes.push(code);
                }
              });
              setModificationsCodes(newCodes);
              setModification(newCodes);
            }catch(err){
              console.error('Failed to read text from clipboard: ', err);
              if(err.name === 'NotAllowedError'){
                alert('Clipboard access denied. Please ensure the page is focused and try again, or use Ctrl/Cmd+V to paste directly into the input field.');
              } else {
                alert('Failed to paste from clipboard. Please try again.');
              }
            }
          }
        }}
        >Paste
      </span>
      <span style={{height: "15px", borderRight: "1px solid #ccc"}}></span>
      <span 
        style={{padding: "0 5px"}} className={disabled ? "disabled" : "ftLinkBlue"} 
        onClick={() => { if(!disabled){setMultiSelect(_.cloneDeep(modificationsCodes)); setModDbBrowser(true); }}}
        >Modification browser
      </span>
    </div>
    {dragStart && dragEnd &&
      <div style={{
        position: "fixed",
        top: Math.min(dragStart.y, dragEnd.y), // Adjust for popup offset
        left: Math.min(dragStart.x, dragEnd.x),
        width: Math.abs(dragEnd.x - dragStart.x),
        height: Math.abs(dragEnd.y - dragStart.y),
        backgroundColor: "rgba(0, 120, 215, 0.3)",
        border: "2px dashed rgba(0, 120, 215, 0.8)",
  
        zIndex: 1001,
        pointerEvents: "none"
      }}>
      </div>
    }
    <GQPopup
      show={modDbBrowser}
      close={()=>{closeModDbBrowser()}}
      innerHtml={   
      <div>
        <div style={{
          outline: "none",
          width: "856px",
        }}>
          <div>
              <span className="center historyPopupHeader tableCaption">Modification database</span>
              <div style={{display: "flex", justifyContent: "space-between", padding: "0"}}>
                <input
                    id="modtreesearchtextbox"
                    onChange={(event)=>setCurrentModSearch(event.target.value)}
                    value={currentModSearch}
                    className="abInput"
                    type="text"
                    style={{width: "100%", borderRadius: "8px", border: "1px solid grey", padding: "5px"}}
                    placeholder="Search for Modifications"
                    autoComplete="off" 
                    spellCheck="false"
                >
                </input>
              </div>
                <div style={{border: "1px solid grey", borderRadius: "8px", margin: "5px 0", height: "370px", overflow: "scroll", userSelect: "none"}}
                  onMouseDown={e => {
                    setDragStart({ x: e.clientX, y: e.clientY});
                  }}
                  onMouseMove={e => {
                    if (dragStart) {
                      setDragEnd({ x: e.clientX, y: e.clientY});
                    }
                  }}
                  onMouseUp={e => {
                    let end = { x: e.clientX, y: e.clientY};
                    // Calculate selected items here
                    // 1. Get bounding rect for each modDataItem div (use refs or querySelectorAll)
                    let items = document.querySelectorAll(`[id^="modItem-"]`);
                    // 2. If the rect intersects with the drag rectangle, add to selection
                    for (let i = 0; i < items.length; i++) {
                      let item = items[i];
                      let rect = item.getBoundingClientRect();
                      //if the top and bottom of the item is within the dragStart and dragEnd y coordinates
                      let dragTop = Math.min(dragStart.y, end.y);
                      let dragBottom = Math.max(dragStart.y, end.y);
                      
                      if (rect.top+5 >= dragTop && rect.bottom-5 <= dragBottom) {
                        let modID = item.id.replace("modItem-", "");
                        if(!multiSelect.toString().includes(modID)){
                          setMultiSelect((prev) => [...prev, modID]);
                        }else{
                          //remove from multiselect
                          setMultiSelect((prev) => prev.filter((id) => id !== modID));
                        }
                      }
                    }
                    // 3. Update multiSelect with the selected Mod_IDs
                    setDragStart(null);
                    setDragEnd(null);
                  }}
                
                >        
                {modTree.children !== undefined &&
                <>      
                  {modTree.children.map((mod, index) => (
                    <RecursiveTree
                      key={index}
                      htmlFn={(node) => (
                        <div style={{padding: "10px", fontSize: "16px"}}>
                          <div>
                            <span
                              style={highlightedPaths.includes(node.fullPath) ? {cursor: "pointer", backgroundColor: "#e0e6ad", color: "#292929", padding: "10px 0 10px 10px", margin:"5px 5px 10px 10px", fontSize: "16px", borderRadius: "8px"} : {padding: "10px 0 10px 10px", margin:"5px 5px 10px 10px", fontSize: "16px", cursor: node.children.length > 0 ? "pointer" : ""}}
                              onClick = {()=>{
                                if(highlightedPaths.includes(node.fullPath)){
                                  setHighlightedPaths((prev) => prev.filter((path) => path !== node.fullPath));
                                  let name = node.fullPath;
                                  for(let i = 0; i< multiSelect.length; i++){
                                      if(multiSelect[i].includes(name)){
                                        if(JSON.parse(multiSelect[i]).name === name){
                                          let multiSelectCopy = [...multiSelect];
                                          multiSelectCopy.splice(i, 1);
                                          setMultiSelect(multiSelectCopy);
                                          break;
                                        }
                                      }
                                  }
                                } else {
                                
                                  let name = node.fullPath;
                                  let values = modList
                                    .filter((mod) => mod.classification_UI === node.fullPath)
                                    
                                    values = values.map(mod => String(mod.Mod_ID));  
                                  if(values.length === 0){
                                    return;
                                  }

                                  setHighlightedPaths((prev) => [...prev, node.fullPath]);
                                  let multiSelectCopy = [...multiSelect];

                                  let myJson = {
                                    name: name,
                                    values: values
                                  };

                                  let text = JSON.stringify(myJson);

                                  for(let i = 0; i < values.length; i++){
                                    if(multiSelectCopy.includes(values[i])){ //remove from multiselect
                                      multiSelectCopy = multiSelectCopy.filter((id) => id !== values[i]);
                                    }
                                  }
                                  //insert insertionJson into multiSelectCopy
                                  multiSelectCopy.push(text);
                                  setMultiSelect(multiSelectCopy);
                                }
                              }}
                            >
                            <strong>{node.classification}</strong>&nbsp;
                            {node.totalCount > 0 &&
                              <span
                                style={{backgroundColor: "#e0e6ad", padding: "5px 10px", borderRadius: "4px", fontSize: "12px", color: "#292929", cursor: "pointer"}}
                              >All {node.totalCount}</span>
                            }
                            </span>
                            {node.modData.length > 0 &&
                              <span
                                style={{position:"relative", zIndex:"6000", width:"min-content", backgroundColor: "#add8e6", padding: "5px 10px", borderRadius: "4px", fontSize: "12px", color: "#292929", cursor: "pointer"}}
                                onClick={()=>{
                                        
                                        let idx = highlightedPaths.indexOf(node.fullPath);
                                        
                                        let hlCopy = [...highlightedPaths];
                                        let multiSelectCopy = [...multiSelect];
                                        
                                        if(idx !== -1){
                                          hlCopy.splice(idx, 1);

                                          for(let i = 0; i< multiSelectCopy.length; i++){
                                            if(multiSelectCopy[i].includes(node.fullPath)){
                                              if(JSON.parse(multiSelectCopy[i]).name === node.fullPath){
                                                multiSelectCopy.splice(i, 1);
                                                break;
                                              }
                                            }
                                          }
                                        }
                                      
                                      
                                        //det array of id;
                                        let ids = []
                                        node.modData.forEach(mod => {
                                          ids.push(String(mod.Mod_ID));
                                        });
                                        
                                        setHighlightedPaths([...hlCopy]);
                                        setMultiSelect([...multiSelectCopy, ...ids]);
                                      
                              }}
                              >Filtered {node.modData.length}
                              </span>
                            }
                          </div>
                          {!highlightedPaths.includes(node.fullPath) && node.modData.map((modDataItem, idx) => (
                            <div
                              style={{
                                fontSize: "14px",
                                borderRadius: "4px",
                                width: "fit-content", 
                                display: "flex", 
                                alignItems:  "center", 
                                margin: "5px 0 0 20px",
                                padding: "2px 5px",
                                cursor: redo === true ? "not-allowed" : "pointer", 
                                background: multiSelect.includes(modDataItem.Mod_ID) ? "lightBlue" : "",
                                color: multiSelect.includes(modDataItem.Mod_ID) ? "black" : "inherit"
                              
                              }}
                              key={modDataItem.Mod_ID}
                              id ={`modItem-${modDataItem.Mod_ID}`}
                              onClick={() => {
                                if(!modificationsCodes.includes(modDataItem.Mod_ID) && !highlightedPaths.includes(node.fullPath)){
                                  if(!multiSelect.includes(modDataItem.Mod_ID)){
                                    setMultiSelect([...multiSelect, modDataItem.Mod_ID]);
                                  } else {
                                    //remove from multiselect
                                    const newSelection = multiSelect.filter((id) => id !== modDataItem.Mod_ID);
                                    setMultiSelect(newSelection);
                                  }
                                }
                              }}
                            >
                              <div>{modDataItem.base}&nbsp;{modDataItem.modification}{modDataItem.Abbreviation && <span>&nbsp;(<span>{modDataItem.Abbreviation}</span>)</span>}</div>
                            </div>
                          ))}
                        </div>
                      )}
                      data={mod}
                    />
                  ))}
                </>
                }
                </div>
                <div style={{width: "100%", padding: "5px", display: "flex", justifyContent: "flex-end"}}>
                    <Button className={"cancelButtonClass "} style={{marginRight: "10px"}} onClick={()=>{closeModDbBrowser();}}>Cancel</Button>
                    
                    <Button className={"submitButtonClass"} onClick={()=>{SelectMulti();}}>Select</Button>
                </div>
              </div>
        </div>
      </div>	
      }/>
  </>
  );
};

export default SelectedModification;
